import { HintIcon, HintText, Wrapper } from "./style";

const InputHint = ({ children, icon = "ℹ️" }) => {
  if (!children) return null;

  return (
    <Wrapper>
      <HintIcon>{icon}</HintIcon>
      <HintText>{children}</HintText>
    </Wrapper>
  );
};

export default InputHint;

